module.exports = __webpack_public_path__ + "static/media/initiatives.632e489d.png";